"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("@mui/material/styles"),p=e.styled("div")`
  height: 56px;
  width: 100%;
`,o=e.styled("div")`
  display: flex;
  align-items: center;
  padding: 18px 16px;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
`,r=e.styled("div")(({theme:t})=>({position:"sticky",zIndex:3,top:"-8px",padding:"12px 16px",borderTop:`1px solid ${t.palette.grey[300]}`,color:t.palette.grey[800],backgroundColor:t.palette.common.white})),i=e.styled("ul")`
  padding: 0;
`,s=e.styled("li")`
  padding: 0;
  list-style: none;
`;exports.GroupHeader=r;exports.GroupItems=i;exports.GroupListWrapper=s;exports.SkeletonDetailsWrapper=o;exports.SkeletonWrapper=p;
